import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Header from '../../../navigation/header/header.js';

import ClaimCreateForm from '../../../components/myquote/claim/claim-create-form.js';
import ClaimView from '../../../components/myquote/claim/claim-view.js';

class ClaimHomeScreen extends React.Component {
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;
		
		this.uuid = this.app.guid();
		
		
		this.state = {
			action: 'create',
			txhash: null,
			loaded: false,
			claiminfo: 'loading...',
		};
	}
	
	// post render commit phase
	componentDidMount() {
		console.log('ClaimHomeScreen.componentDidMount called');
		let mvcmodule = this.getMvcModuleObject();
		
		mvcmodule.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));
		
		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		
		let app_nav_target = this.app.getNavigationState('target');

		if (app_nav_target && (app_nav_target.route == 'claim') && (app_nav_target.reached == false)) {
			var params = app_nav_target.params;

			if (params) {
				let action = (params.action ? params.action : 'view');
				let txhash = params.txhash;
				let claiminfo = '';
	
				if (txhash) {
					// retrieve info from firenze
					claiminfo = txhash;
				}
	
				this.setState({txhash, action, claiminfo});
			}

			// QuoteView will take care of marking target reached
		}

		this.setState({loaded: true});
	}

	async onRefreshPage() {
		console.log('ClaimHomeScreen.onRefreshPage called');

		return this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	

	// end of life
	componentWillUnmount() {
		console.log('ClaimHomeScreen.componentWillUnmount called');
		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
		mvcmodule.unregisterEventListener('on_refreshPage', this.uuid);
	}
	
	
	render() {
		let {loaded, action, claiminfo} = this.state;

		return (
			<div className="Screen">
				<Header app = {this.app} />
				{(loaded === true ?
				(action === 'view' ?
				<ClaimView app = {this.app} /> :
				<ClaimCreateForm app = {this.app} />)
				: <div>{claiminfo}</div>)}
			</div>
		);
	}
}

// propTypes validation
ClaimHomeScreen.propTypes = {
	app: PropTypes.object.isRequired,
};



export default ClaimHomeScreen;